export const MyBootCampType = {
  ALL: '전체',
  COMPLETED: '신청완료',
  IN_CLASS: '수강중',
  CLOSED: '마감',
} as const;

export type MyBootCampType = keyof typeof MyBootCampType;
